// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 继承修饰符枚举 枚举类
 * 继承修饰符枚举
 */
export enum EnumInheritanceModifier {
  /** 无 : 无 */
  None = 0,
  /** 抽象类 : 抽象类 */
  Abstract = 1,
  /** 最终类 : 最终类 */
  Sealed = 2
}

/**
 * 继承修饰符枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumInheritanceModifierMD {
  private static items = [
    new EnumItemMD('None', 0, '无', '无'),
    new EnumItemMD('Abstract', 1, '抽象类', '抽象类'),
    new EnumItemMD('Sealed', 2, '最终类', '最终类')
  ];

  static getItem(enumItem: EnumInheritanceModifier) {
    return this.items.find(item => item.name === EnumInheritanceModifier[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
